import React, { useState, useEffect } from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
  InfoWindow,

} from "react-google-maps";
import "./viewmapform.css";


function Map(props) {
  const [selectedRetailer, setSelectedRetailer] = useState(null);
  var obj = props.data;
  const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");

  return (
    <div>
      <GoogleMap
        defaultZoom={12}
        defaultCenter={{ lat: obj[0].lat, lng: obj[0].lon }}

      >
        <MarkerClusterer
          onClick={props.data.onMarkerClustererClick}
          averageCenter
          enableRetinaIcons
          gridSize={60}
          minimumClusterSize={30}
        >
          {obj.map((items, index) => (
            <Marker
              key={index}
              position={{
                lat: items.lat,
                lng: items.lon
              }}
              onClick ={()=>props.alertmarker(items)}
              onMouseOver={() => {
                setSelectedRetailer(items);
              }}
              onMouseOut={() => {
                setSelectedRetailer(null);
              }}
              icon={{
                url: items.icon,
                scaledSize: new window.google.maps.Size(55, 55),
                anchor: new window.google.maps.Point(
                  20, // width
                  10 //  height
                ),
              }}
              label={{
                text: items.index,
                fontWeight: "bold",
                fontSize: "11.5px",
                className: "map_label",

              }}
            />
          ))}
        </MarkerClusterer>
        {selectedRetailer && (
          <InfoWindow
            onCloseClick={() => {
              setSelectedRetailer(null);
            }}
            position={{
              lat: selectedRetailer.lat,
              lng: selectedRetailer.lon
            }}
          >
            <div>

              <h4>Bill No : {selectedRetailer.bill}</h4>
              <h5>Party Code : {selectedRetailer.party_list}</h5>

            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}

const MapWrapped = withScriptjs(withGoogleMap(Map));

export default function App(props) {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!googleMapsApiKey) {
  console.error('Google Maps API key is not configured');
  return <div>Error: Map configuration is missing</div>;
}
  return (
    <div style={{ width: "72.5vw", height: "99vh", marginTop: "4px" }}>
      <MapWrapped
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${googleMapsApiKey}`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        data={props.data}
        alertmarker={props.alertmarker}
      />
    </div>
  );
}
